import request from '@/utils/request'

export const userApi = {
  // 获取用户列表
  getUsers(params) {
    return request({
      url: '/users/',
      method: 'get',
      params
    })
  },

  // 获取单个用户
  getUser(id) {
    return request({
      url: `/users/${id}/`,
      method: 'get'
    })
  },

  // 创建用户
  createUser(data) {
    return request({
      url: '/users/',
      method: 'post',
      data
    })
  },

  // 更新用户
  updateUser(id, data) {
    return request({
      url: `/users/${id}/`,
      method: 'put',
      data
    })
  },

  // 删除用户
  deleteUser(id) {
    return request({
      url: `/users/${id}/`,
      method: 'delete'
    })
  },

  // 登录
  login(data) {
    return request({
      url: '/users/login',
      method: 'post',
      data
    })
  },

  // 注册
  register(data) {
    return request({
      url: '/users/register',
      method: 'post',
      data
    })
  },

  // 退出登录
  logout(data) {
    return request({
      url: '/users/logout',
      method: 'post',
      data
    })
  },

  // 发送邮箱验证码
  sendEmailCode(data) {
    return request({
      url: '/users/email-verify',
      method: 'post',
      data
    })
  },

  // 获取当前用户信息
  getCurrentUser() {
    return request({
      url: '/users/me/',
      method: 'get'
    })
  },

  // 修改密码
  changePassword(data) {
    return request({
      url: '/users/change-password/',
      method: 'post',
      data
    })
  },

  // 更新用户信息
  updateProfile(data) {
    return request({
      url: '/users/me/',
      method: 'patch',
      data
    })
  },

  // 更新用户状态
  updateUserStatus(id, data) {
    return request({
      url: `/users/${id}/update_status/`,
      method: 'patch',
      data
    })
  },

  // 修改用户密码
  changeUserPassword(id, data) {
    return request({
      url: `/users/${id}/change_password/`,
      method: 'post',
      data
    })
  }
} 